<div class="patient-handler-modal">

  <!-- Modal Content -->
  <div class="u-ph+ u-pt u-pb0 modal__content">

    <!-- Notification -->
    <div id="notification-container">
      <div *ngFor="let note of notifications | keyvalue">
        <div class="u-pb" *ngIf="note.value.show">
          <wfm-system-notification
            id="{{ note.value.id }}-notification"
            [type]="note.value.type"
            size="medium"
            [multiLineLayout]="note.value.multiLineLayout"
            [headingText]="note.value.label"
            [hideCloseButton]="note.value.hideClose"
            (close)="note.value.show = false">
          </wfm-system-notification>
        </div>
      </div>
    </div>

    <!-- Sub tittle -->
    <div class="info-header u-pb" *ngIf="!loadError">
      <span> {{'label.patientInfo'| translate}} </span>
    </div>

    <!-- spinner -->
    <div *ngIf="loading" id="spinner-component" class="flex flex--center readonly-textbox">
      <wfm-spinner [show]="true" [size]="40"></wfm-spinner>
    </div>

    <!-- Form -->
    <form [formGroup]="patientHandlerForm" *ngIf="!loading && !loadError">
      <div class="flex flex--nowrap flex--row">
        <!-- Name -->
        <div class="form__fieldset row-fluid">
          <label for="patientName" class="form__label form__label--bottom">
            <span class="form__label-inner-wrap">
              <span> {{'label.patientName' | translate}} <span aria-label="required">*</span> </span>
            </span>
          </label>
          <div class="flex flex--nowrap flex--row" id="patientName">
            <input formControlName="patientName" type="text" class="textbox"
              placeholder="{{'placeholder.patientName' | translate}}"
              [tooltip]="formControls.patientName.value" (input)="onInput()"
              [attr.aria-invalid]="formControls.patientName.invalid" maxLength="40" required/>
          </div>
          <div *ngIf="formControls.patientName.invalid && (formControls.patientName.touched || formControls.patientName.dirty)">
            <div role="alert" class="form__error-text" id="nameError">
              <div class="flex flex--row flex--middle">
                <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }"></svg-icon>

                <span id="error-message" class="u-ml----" *ngIf="formControls.patientName.errors?.required">
                  {{ 'msg.patient.error.name.required' | translate }}
                </span>
                <span
                  id="error-message"
                  class="u-ml----"
                  *ngIf="formControls.patientName.errors?.specialChar || formControls.patientName.errors?.invalidStart ">
                  {{ 'msg.error.invalidInputCharacters' | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Local I Name -->
        <div class="form__fieldset row-fluid u-pl--" *ngIf="config.data.localPatientNameDisplay">
          <label for="iPatName" class="form__label form__label--bottom">
            <span class="form__label-inner-wrap">
              <span> {{'label.localPatientIName' | translate}} </span>
            </span>
          </label>
          <div class="flex flex--nowrap flex--row" id="iPatName">
            <input formControlName="iPatName" dir="auto" type="text" class="textbox"
              [attr.aria-invalid]="formControls.iPatName.invalid" maxlength="255" (input)="onInput()"
              [tooltip]="formControls.iPatName.value"
            />
          </div>
          <div *ngIf="formControls.iPatName.invalid && (formControls.iPatName.touched || formControls.iPatName.dirty)">
            <div role="alert" class="form__error-text" id="iPatNameError">
              <div class="flex flex--row flex--middle">
                <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }"></svg-icon>

                <span id="error-message" class="u-ml----">
                  {{ 'msg.error.invalidInputCharacters' | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex--nowrap flex--row u-mt--">
        <div class="form__fieldset row-fluid u-pr--">
          <label for="gender" class="form__label form__label--bottom">
            <span class="form__label-inner-wrap">
              <span>{{'label.gender' | translate}}</span>
            </span>
          </label>
          <div id="gender">
            <wfm-select-dropdown
              placeholder="placeholder.gender"
              [required]="true"
              [items]="genderList"
              labelField="desc"
              [disabled]="formControls.gender.disabled || patientHandlerForm.disabled"
              [value]="formControls.gender.value"
              (valueChange)="setUserSelection('gender', $event)">
            </wfm-select-dropdown>
          </div>
        </div>

        <div class="form__fieldset row-fluid u-pr--">
          <label for="dob" class="form__label form__label--bottom">
            <span class="form__label-inner-wrap">
              <span> {{'label.dob'| translate}} <span aria-label="required">*</span> </span>
            </span>
          </label>
          <div id="editPatientDoB" (keydown)="dobDateBoxvalueChanged()">
            <wfm-date-picker
              [format]="dateDisplayFormat"
              [placeholder]="dateFormat"
              [disabled]="formControls.dob.disabled || patientHandlerForm.disabled"
              [autoWidth]="false"
              [hideOtherMonths]="true"
              [min]="undefined"
              [max]="todayEod"
              [rangeMode]="false"
              [compactMode]="true"
              [value]="formControls.dob.value"
              (valueChange)="setUserSelection('dob', $event)"
              [attr.aria-invalid]="formControls.dob.invalid">
            </wfm-date-picker>
            <div *ngIf="formControls.dob.value === undefined && !dobInEditing">
              <div role="alert" class="form__error-text" id="dobError">
                <div class="flex flex--row flex--middle">
                  <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }"></svg-icon>
                  <span id="error-message" class="u-ml----">
                    {{ 'msg.error.dateRequired' | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form__fieldset row-fluid">
          <label for="patientLocation" class="form__label form__label--bottom">
            <span class="form__label-inner-wrap">
              <span>{{'label.patientLocation' | translate}}</span>
            </span>
          </label>
          <div id="patientLocation">
            <wfm-select-dropdown
              placeholder="placeholder.patientLocation"
              [required]="true"
              [items]="patientLocationList"
              labelField="locationDesc"
              [disabled]="formControls.location.disabled || patientHandlerForm.disabled"
              [value]="formControls.location.value"
              (valueChange)="setUserSelection('location', $event)">
            </wfm-select-dropdown>
          </div>
        </div>
      </div>
      <div class="flex flex--nowrap flex--row u-mt--">
        <div class="form__fieldset row-fluid u-pr--">
          <label for="domain" class="form__label form__label--bottom">
            <span class="form__label-inner-wrap">
              <span>{{ 'label.domain' | translate}}</span>
            </span>
          </label>
          <div id="domain">
            <wfm-select-dropdown
              placeholder="placeholder.domain"
              [required]="true"
              [items]="domainList"
              labelField="authorityLocalName"
              [disabled]="formControls.domain.disabled || patientHandlerForm.disabled"
              [value]="formControls.domain.value"
              (valueChange)="setUserSelection('domain', $event)">
            </wfm-select-dropdown>
          </div>
        </div>

        <div class="form__fieldset row-fluid u-pr--">
          <label for="domainPatientId" class="form__label form__label--bottom">
            <span class="form__label-inner-wrap">
              <span>{{'label.patientId' | translate}} <span aria-label="required">*</span></span>
            </span>
          </label>
          <div class="flex flex--nowrap flex--row" id="domainPatientId">
            <input formControlName="domainPatientId" type="text" class="textbox"
              [attr.aria-invalid]="formControls.domainPatientId.invalid" maxlength="64" required
              (input)="onInput()" [tooltip]="formControls.domainPatientId.value" [attr.readonly]="isMRNNumberEditable ? null : true"
              *ngIf="isMRNNumberEditable; else elseBlock" />
            <ng-template #elseBlock>
              <input formControlName="domainPatientId" type="text" class="readonly-textbox textbox u-pl0"
                [tooltip]="formControls.domainPatientId.value" [attr.readonly]=true />
            </ng-template>
          </div>
          <div *ngIf="formControls.domainPatientId.invalid && (formControls.domainPatientId.touched || formControls.domainPatientId.dirty)">
            <div role="alert" class="form__error-text" id="domainPatientIdError">
              <div class="flex flex--row flex--middle">
                <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }"></svg-icon>

                <span id="error-message" style="word-break: auto-phrase" class="u-ml----" *ngIf="formControls.domainPatientId.errors?.required || formControls.domainPatientId.errors?.invalidStart
                || formControls.domainPatientId.errors?.pattern?.requiredPattern">
                  {{ 'msg.patientId.error.invalidOrRequired' | translate }}
                </span>
                <span
                  id="error-message"
                  style="word-break: auto-phrase"
                  class="u-ml----"
                  *ngIf="formControls.domainPatientId.errors?.specialChar && !formControls.domainPatientId.errors?.pattern?.requiredPattern">
                  {{ 'msg.patientId.error.invalidInputCharacters' | translate }}
                </span>
              </div>
            </div>
          </div>

        </div>

        <div class="form__fieldset row-fluid">
          <label for="confidential" class="form__label form__label--bottom">
            <span class="form__label-inner-wrap">
              <span>{{'label.confidential' | translate}}</span>
            </span>
          </label>
          <div id="confidential">
            <div *ngIf="!config.data.confidentialPrivilege; else selectableConfidentialTemplate" [tooltip]="formControls.confidentialPatient.value?.desc">
              <input
                [value]="formControls.confidentialPatient.value.desc"
                type="text"
                class="readonly-textbox textbox u-pl0"
                [disabled]="patientHandlerForm.disabled" readonly />
            </div>
            <ng-template #selectableConfidentialTemplate>
              <wfm-select-dropdown
                placeholder="placeholder.confidential"
                [required]="true"
                [items]="confidentialities"
                labelField="desc"
                [disabled]="formControls.confidentialPatient.disabled || patientHandlerForm.disabled"
                [value]="formControls.confidentialPatient.value"
                (valueChange)="setUserSelection('confidentialPatient', $event)">
              </wfm-select-dropdown>
            </ng-template>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Modal Footer -->
  <div class="flex flex--row u-ph+ u-pv" style="justify-content: right;">
    <button type="button"
            *ngIf="loadError"
            class="button button--reject button--tertiary u-ml--"
            (click)="closeModal(); $event.stopPropagation()">
      {{ 'button.ok' | translate }}
    </button>
    <button type="button"
            *ngIf="!loadError"
            [disabled]="loading || patientHandlerForm.pristine || patientHandlerForm.disabled || !patientHandlerForm.dirty"
            class="button button--tertiary u-ml--"
            (click)="resetForm(); $event.stopPropagation()">
      {{ 'button.reset' | translate }}
    </button>
    <button type="button"
            *ngIf="!loadError"
            [disabled]="loading || patientHandlerForm.pristine || patientHandlerForm.invalid || patientHandlerForm.disabled || !patientHandlerForm.dirty || isErrorPopUp"
            class="button button--primary button--accept u-ml--"
            (click)="updatePatient(); $event.stopPropagation()">
      {{ 'button.save' | translate }}
    </button>
  </div>
</div>
